import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const navigate = useNavigate();
  
  // Sample cart items
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: 'iPhone 13 OLED Screen',
      price: 129.99,
      quantity: 1,
      image: 'https://via.placeholder.com/100x100?text=iPhone+Screen'
    },
    {
      id: 2,
      name: 'Samsung Galaxy S21 Battery',
      price: 49.99,
      quantity: 2,
      image: 'https://via.placeholder.com/100x100?text=Galaxy+Battery'
    }
  ]);
  
  // Calculate totals
  const subtotal = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  const shipping = subtotal > 50 ? 0 : 9.99;
  const total = subtotal + shipping;
  
  // Remove item from cart
  const removeItem = (id) => {
    setCartItems(cartItems.filter(item => item.id !== id));
  };
  
  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', py: 4 }}>
      <Container>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#006938', display: 'flex', alignItems: 'center' }}>
          <ShoppingCartIcon sx={{ mr: 1 }} /> Shopping Cart
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>Cart Items</Typography>
              
              {cartItems.length === 0 ? (
                <Typography>Your cart is empty</Typography>
              ) : (
                <List>
                  {cartItems.map((item) => (
                    <ListItem 
                      key={item.id}
                      secondaryAction={
                        <IconButton edge="end" onClick={() => removeItem(item.id)}>
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemAvatar>
                        <Avatar src={item.image} variant="square" />
                      </ListItemAvatar>
                      <ListItemText 
                        primary={item.name} 
                        secondary={`Quantity: ${item.quantity}`} 
                      />
                      <Typography variant="body1" sx={{ ml: 2 }}>
                        ${(item.price * item.quantity).toFixed(2)}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              )}
              
              <Button 
                variant="outlined" 
                onClick={() => navigate('/parts')}
                sx={{ mt: 2, color: '#006938', borderColor: '#006938' }}
              >
                Continue Shopping
              </Button>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>Order Summary</Typography>
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography>Subtotal:</Typography>
                <Typography>${subtotal.toFixed(2)}</Typography>
              </Box>
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography>Shipping:</Typography>
                <Typography>${shipping.toFixed(2)}</Typography>
              </Box>
              
              <Divider sx={{ my: 2 }} />
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6">Total:</Typography>
                <Typography variant="h6">${total.toFixed(2)}</Typography>
              </Box>
              
              <Button 
                variant="contained" 
                fullWidth
                sx={{ bgcolor: '#006938', '&:hover': { bgcolor: '#004d2b' } }}
              >
                Checkout
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Cart;
